import { useTypedSelector } from '../redux/hooks';

export const usePointLocation = () => {
  const { selectedLocation, detectedLocation } = useTypedSelector(
    s => s.location
  );
  return selectedLocation || detectedLocation;
};
